export default "__VITE_ASSET__DCyrPH5r__"